/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_No_UsersInputs */

const en_admin_users_no_users = /** @type {(inputs: Admin_Users_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users yet`)
};

const zh_admin_users_no_users = /** @type {(inputs: Admin_Users_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无用户`)
};

/**
* | output |
* | --- |
* | "No users yet" |
*
* @param {Admin_Users_No_UsersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_no_users = /** @type {((inputs?: Admin_Users_No_UsersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_No_UsersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_no_users(inputs)
	return zh_admin_users_no_users(inputs)
});
export { admin_users_no_users as "admin.users.no_users" }